<template>
  <card-dialog
    v-model="modalVisible"
    max-width="1300px"
    :title="injury.data ? injury.data.title : ''"
  >
    <template v-slot:title>
      <v-card-title
        v-if="injury.data"
        class="blue-grey lighten-5 px-6 py-4"
      >
        <div>
          <div>
            {{ injury.data.title }}
          </div>
          <div class="text-body-1 mt-1">
            <router-link :to="{ name: $routeNames.PLAYER_DETAILS, params: { id: player.id } }">
              {{ player.first_name }} {{ player.last_name }}
            </router-link>
          </div>
        </div>
      </v-card-title>
    </template>

    <v-card-text
      v-if="injury.data"
      class="pa-0"
    >
      <v-row
        no-gutters
        class="fill-height"
      >
        <v-col
          cols="3"
          class="pa-4 grey lighten-5 fill-height overflow-auto"
        >
          <v-row
            v-if="hasItlModule || hasGpsModule || hasHrModule"
            no-gutters
            class="text-body-1 pa-3 phase-selector"
            align="center"
            :class="{ 'completed': true, 'active': injuryPhasePreInjury === selectedPhaseKey }"
            @click="selectedPhaseKey = injuryPhasePreInjury"
          >
            <v-col
              cols="auto"
              class="pr-2"
            >
              <v-avatar
                color="primary"
                size="22px"
              >
                <span class="white--text font-weight-regular caption"> 0 </span>
              </v-avatar>
            </v-col>
            <v-col class="font-weight-medium">
              {{ $t('injury_individual.status.pre_injury') }}
            </v-col>
          </v-row>
          <v-divider
            v-if="hasItlModule || hasGpsModule || hasHrModule"
            class="my-1"
          />
          <template
            v-for="(phase, index) in injuryPhases"
          >
            <v-row
              :key="phase.key"
              no-gutters
              class="text-body-1 pa-3 phase-selector"
              align="center"
              :class="{ 'completed': !!phase.date, 'disabled': !phase.date, 'active': phase.key === selectedPhaseKey }"
              @click="selectedPhaseKey = phase.key"
            >
              <v-col
                cols="auto"
                class="pr-2"
              >
                <v-avatar
                  :color="!!phase.date ? 'primary' : 'grey lighten-2'"
                  size="22px"
                >
                  <span class="white--text font-weight-regular caption">{{ index + 1 }}</span>
                </v-avatar>
              </v-col>
              <v-col :class="{ 'font-weight-medium': !!phase.date, 'grey--text': !phase.date }">
                {{ phase.text }}
              </v-col>
              <v-col
                v-if="phase.date"
                cols="auto"
                class="caption grey--text"
              >
                {{ $dayjs(phase.date).format('ll') }}
              </v-col>
            </v-row>
          </template>

          <div v-if="selectedNextPhase && (hasItlModule || hasGpsModule || hasHrModule)">
            <v-divider
              class="my-8"
              horizontal
            />

            <v-row class="ml-0">
              <v-col>
                <subtitle>
                  {{ $t('injury_individual.analyse_performance') }}
                </subtitle>
              </v-col>
            </v-row>
            <v-row v-if="hasGpsModule">
              <v-col class="py-1">
                <v-btn
                  block
                  text
                  color="primary"
                  class="text-none"
                  :to="{ name: $routeNames.PERFORMANCE_ADVANCED, query: { from: selectedPhase.date, to:selectedNextPhase.date, player_id: player.id, team_id: player.team_id } }"
                >
                  <v-row no-gutters>
                    <v-col align="left">
                      {{ $t('performance.event.gps') }}
                    </v-col>
                    <v-col cols="auto">
                      <v-icon>
                        fa-arrow-right
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="hasTrainingBuilderModule">
              <v-col class="py-1">
                <v-btn
                  block
                  text
                  color="primary"
                  class="text-none"
                  :to="{ name: $routeNames.PLAYER_TRAINING_EXERCISES, params: { id: player.id }, query: { from: selectedPhase.date, to: selectedNextPhase.date} }"
                >
                  <v-row no-gutters>
                    <v-col align="left">
                      {{ $t('injury_individual.training_exercise') }}
                    </v-col>
                    <v-col cols="auto">
                      <v-icon>
                        fa-arrow-right
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="hasItlModule">
              <v-col class="py-1">
                <v-btn
                  block
                  text
                  color="primary"
                  class="text-none"
                  :to="{ name: $routeNames.PLAYER_LOAD, params: { id: player.id }, query: { to: selectedNextPhase.date} }"
                >
                  <v-row no-gutters>
                    <v-col align="left">
                      {{ $t('injury_individual.training_load') }}
                    </v-col>
                    <v-col cols="auto">
                      <v-icon>
                        fa-arrow-right
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col class="pa-4 fill-height overflow-auto pa-6">
          <div
            class="droparea"
            style="min-height: 500px"
            @dragenter.prevent="dragenter"
          >
            <v-row
              v-if="selectedPhaseKey !== injuryPhasePreInjury"
              no-gutters
              class="grey lighten-5 px-4 py-2 mb-6 caption"
              align="center"
              style="border-radius: 10px"
            >
              <v-col
                cols="auto"
                class="text-body-1"
              >
                {{ $t("player_card.status.label") }} <strong>{{ selectedPhase ? selectedPhase.text : '' }}</strong>
                &middot;
                {{ $dayjs(selectedPhase ? selectedPhase.date : undefined).format('ll') }}
              </v-col>
              <v-col
                cols="auto"
                class="pl-3"
              >
                <v-btn
                  small
                  text
                  class="text-none"
                  color="grey"
                  @click="initEditPhase()"
                >
                  <v-icon
                    left
                    x-small
                  >
                    far fa-pen
                  </v-icon>
                  {{ $t("button.edit") }}
                </v-btn>
              </v-col>
              <v-spacer />

              <v-col
                v-if="selectedPhase"
                cols="auto"
                class="text--secondary"
              >
                {{ $t("initiated_by.label", {user: selectedPhase.created_by_user.first_name + ' ' + selectedPhase.created_by_user.last_name, date: $dayjs(selectedPhase.created_at).format(getDateTimeFormatForUser('ll HH:mm:ss'))}) }}
              </v-col>
            </v-row>

            <div v-if="selectedPhaseKey === injuryPhaseInjury">
              <v-row
                no-gutters
                align="center"
                class="mb-6"
              >
                <v-col>
                  <subtitle>
                    {{ $t('injury_individual.injury.injury_details') }}
                  </subtitle>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    v-if="$can('edit-medical')"
                    text
                    color="primary"
                    class="text-none"
                    @click="EventBus.$emit($events.EDIT_INJURY, injury.data)"
                  >
                    <v-icon
                      left
                      small
                    >
                      far fa-pen
                    </v-icon>
                    {{ $t('button.edit_injury') }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-row
                class="mb-8"
                no-gutters
              >
                <v-col>
                  <v-row>
                    <v-col class="justify-center d-flex">
                      <human-body-female-front-muscles
                        v-if="player.gender === 'female'"
                        style="height: 340px; width: 180px"
                        :stats="bodyParts"
                      />
                      <human-body-front-muscles
                        v-else
                        style="height: 340px; width: 180px"
                        :stats="bodyParts"
                      />
                    </v-col>
                    <v-col class="justify-center d-flex">
                      <human-body-female-back-muscles
                        v-if="player.gender === 'female'"
                        style="height: 340px; width: 180px"
                        :stats="bodyParts"
                      />
                      <human-body-back-muscles
                        v-else
                        style="height: 340px; width: 180px"
                        :stats="bodyParts"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="text-body-1">
                  <v-row
                    no-gutters
                    class="px-3"
                  >
                    <v-col
                      cols="4"
                      class="font-weight-bold"
                    >
                      {{ $t('table_headers.medical.latest_injuries.injury') }}
                    </v-col>
                    <v-col>
                      {{ injury.data.injury_types.map(t => this.$t(`injuryType.${toCamelCase(t.type)}`)).join(', ') }}
                    </v-col>
                  </v-row>
                  <v-divider class="grey lighten-4 my-3" />
                  <v-row
                    no-gutters
                    class="px-3"
                  >
                    <v-col
                      cols="4"
                      class="font-weight-bold"
                    >
                      {{ $t("add_new.location") }}
                    </v-col>
                    <v-col class="">
                      {{ bodyPartsText }}
                    </v-col>
                  </v-row>
                  <v-divider class="grey lighten-4 my-3" />
                  <v-row
                    no-gutters
                    class="px-3"
                  >
                    <v-col
                      cols="4"
                      class="font-weight-bold"
                    >
                      {{ $t('table_headers.medical.latest_injuries.recurrent') }}
                    </v-col>
                    <v-col class="">
                      {{ injury.data.recurrent ? $t('status.yes') : $t('status.no') }}
                    </v-col>
                  </v-row>
                  <v-divider class="grey lighten-4 my-3" />
                  <v-row
                    no-gutters
                    class="px-3"
                  >
                    <v-col
                      cols="4"
                      class="font-weight-bold"
                    >
                      {{ $t('dropdown.character.title') }}
                    </v-col>
                    <v-col
                      v-if="injury.data.character"
                      class=""
                    >
                      {{ character[injury.data.character].text }}
                    </v-col>
                    <v-col
                      v-else
                      class="grey--text"
                    >
                      N/A
                    </v-col>
                  </v-row>
                  <v-divider class="grey lighten-4 my-3" />
                  <v-row
                    no-gutters
                    class="px-3"
                  >
                    <v-col
                      cols="4"
                      class="font-weight-bold"
                    >
                      {{ $t('table_headers.medical.latest_injuries.contact') }}
                    </v-col>
                    <v-col
                      v-if="injury.data.contact"
                      class=""
                    >
                      {{ contact[injury.data.contact].text }}
                    </v-col>
                    <v-col
                      v-else
                      class="grey--text"
                    >
                      {{ $t('contact.no_contact') }}
                    </v-col>
                  </v-row>
                  <v-divider class="grey lighten-4 my-3" />
                  <v-row
                    no-gutters
                    class="px-3"
                  >
                    <v-col
                      cols="4"
                      class="font-weight-bold"
                    >
                      {{ $t('dropdown.mechanism.title') }}
                    </v-col>
                    <v-col
                      v-if="injury.data.mechanism"
                      class=""
                    >
                      {{ mechanism[injury.data.mechanism].text }}
                    </v-col>
                    <v-col
                      v-else
                      class="grey--text"
                    >
                      N/A
                    </v-col>
                  </v-row>
                  <v-divider class="grey lighten-4 my-3" />
                  <v-row
                    no-gutters
                    class="px-3"
                  >
                    <v-col
                      cols="4"
                      class="font-weight-bold"
                    >
                      {{ $t('injury.surface.label') }}
                    </v-col>
                    <v-col
                      v-if="injury.data.injury_surface"
                      class=""
                    >
                      {{ $t(`surface.${injury.data.injury_surface.slug}`) }}
                    </v-col>
                    <v-col
                      v-else
                      class="grey--text"
                    >
                      N/A
                    </v-col>
                  </v-row>
                  <v-divider class="grey lighten-4 my-3" />
                </v-col>
              </v-row>
            </div>

            <div v-if="selectedPhaseKey === injuryPhasePreInjury">
              <subtitle class="mb-6">
                {{ $t('injury_individual.pre_injury.pre_injury_trend') }}
              </subtitle>
              <v-row
                class="mb-2"
              >
                <v-col
                  v-if="hasItlModule && itlVariables.length > 0"
                  cols="12"
                >
                  <section class="fill-height">
                    <line-chart
                      class="fill-height"
                      :height="180"
                      :colors="['#FF4560']"
                      :raw-data="trendStats.data"
                      :chart-value-keys="[ { key: selectedITLVariable.key, label: selectedITLVariable.text, type: 'line' } ]"
                      x-value="date"
                      y-value-prefix="stats."
                    >
                      <template v-slot:header>
                        <v-card-title class="px-6 py-0">
                          <v-row
                            class="my-0 py-0"
                            align="center"
                            justify="center"
                          >
                            <v-col class="subtitle-2 grey--text text--grey-100">
                              {{ $t('card_title.itl') }}
                            </v-col>
                            <v-col cols="auto">
                              <v-select
                                v-model="selectedITLVariable"
                                :items="orderBy(itlVariables, ['text'], ['asc'])"
                                return-object
                                item-value="key"
                                item-text="text"
                                label="ITL vars"
                                background-color="white"
                                solo
                                hide-details
                                style="width: 250px"
                              />
                            </v-col>
                          </v-row>
                        </v-card-title>
                      </template>
                    </line-chart>
                  </section>
                </v-col>
                <v-col
                  v-if="hasGpsModule && gpsVariables.length > 0"
                  cols="12"
                >
                  <section class="fill-height">
                    <line-chart
                      class="fill-height"
                      :height="180"
                      :colors="['#FF4560']"
                      :raw-data="trendStats.data"
                      :chart-value-keys="[ { key: selectedGPSVariable.value + '_DL', label: selectedGPSVariable.text, type: 'line' } ]"
                      x-value="date"
                      y-value-prefix="stats."
                    >
                      <template v-slot:header>
                        <v-card-title class="px-6 py-0">
                          <v-row
                            class="my-0 py-0"
                            align="center"
                            justify="center"
                          >
                            <v-col class="subtitle-2 grey--text text--grey-100">
                              {{ $t('performance.event.gps') }}
                            </v-col>
                            <v-col cols="auto">
                              <v-select
                                v-model="selectedGPSVariable"
                                :items="orderBy(gpsVariables, 'text', 'asc')"
                                return-object
                                item-value="value"
                                item-text="text"
                                label="GPS vars"
                                background-color="white"
                                solo
                                hide-details
                                style="width: 250px"
                              />
                            </v-col>
                          </v-row>
                        </v-card-title>
                      </template>
                    </line-chart>
                  </section>
                </v-col>
                <v-col
                  v-if="hasHrModule && hrVariables.length > 0"
                  cols="12"
                >
                  <section class="fill-height">
                    <line-chart
                      class="fill-height"
                      :height="180"
                      :colors="['#FF4560']"
                      :raw-data="trendStats.data"
                      :chart-value-keys="[ { key: selectedHRVariable.value + '_DL', label: selectedHRVariable.text, type: 'line' } ]"
                      x-value="date"
                      y-value-prefix="stats."
                    >
                      <template v-slot:header>
                        <v-card-title class="px-6 py-0">
                          <v-row
                            class="my-0 py-0"
                            align="center"
                            justify="center"
                          >
                            <v-col class="subtitle-2 grey--text text--grey-100">
                              {{ $t('card_title.heart_rate') }}
                            </v-col>
                            <v-col cols="auto">
                              <v-select
                                v-model="selectedHRVariable"
                                :items="orderBy(hrVariables, 'text', 'asc')"
                                return-object
                                item-value="value"
                                item-text="text"
                                label="HR vars"
                                background-color="white"
                                solo
                                hide-details
                                style="width: 250px"
                              />
                            </v-col>
                          </v-row>
                        </v-card-title>
                      </template>
                    </line-chart>
                  </section>
                </v-col>
              </v-row>
            </div>

            <div v-if="selectedPhaseKey !== injuryPhasePreInjury">
              <v-row
                no-gutters
                class="mb-3"
                align="center"
              >
                <v-col>
                  <subtitle>
                    {{ $t('injury_individual.notes') }}
                  </subtitle>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    v-if="$can('edit-medical')"
                    text
                    color="primary"
                    class="text-none"
                    @click="newNote.dialog = true"
                  >
                    <v-icon
                      left
                      small
                    >
                      far fa-plus
                    </v-icon>
                    {{ $t('add_note.dialog.header') }}
                  </v-btn>
                </v-col>
              </v-row>

              <div v-if="!selectedPhase || !selectedPhase.notes || selectedPhase.notes.length === 0">
                <div class="text-center text-subtitle-1 grey--text mt-6">
                  <div>
                    <v-icon
                      large
                      class="grey--text text--lighten-2"
                    >
                      fal fa-notes
                    </v-icon>
                  </div>
                  <div class="mt-3">
                    {{ $t('notes_empty') }}
                  </div>
                </div>
              </div>
              <div
                v-else
              >
                <player-note
                  v-for="note in selectedPhase.notes"
                  :key="note.id"
                  :note="note"
                  :has-pinned-option="false"
                  :has-visible-by-player-option="false"
                  class="mb-4"
                  @update="fetchInjury(false)"
                />
              </div>

              <v-row
                no-gutters
                class="mb-3 mt-8"
                align="center"
              >
                <v-col>
                  <subtitle>
                    {{ $t('injury_individual.documents') }}
                  </subtitle>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    text
                    color="primary"
                    class="text-none"
                    @click="$refs.uploadFile.click()"
                  >
                    <v-icon
                      left
                      small
                    >
                      far fa-plus
                    </v-icon>
                    {{ $t('button.add_media') }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-overlay
                color="white"
                light
                :value="fileUpload.isDragging"
                :opacity="0.8"
                @dragleave.prevent="dragleave"
                @dragover.prevent="dragover"
                @drop.prevent="drop"
              >
                <div
                  class="mb-4 text-center"
                  style="pointer-events: none"
                >
                  <v-icon
                    x-large
                    color="grey darken-4"
                  >
                    fal fa-upload
                  </v-icon>
                </div>
                <div
                  class="grey--text text--darken-4"
                  style="pointer-events: none"
                >
                  {{ $t('card_title.release_to_upload') }}
                </div>
              </v-overlay>

              <input
                id="upload-file"
                ref="uploadFile"
                type="file"
                multiple
                style="display: none"
                accept="video/*,audio/*,image/*,.doc,.docx,.pptx,.xlsx,.xls,application/pdf,application/octet-stream"
                @input="handleFileChange"
              >

              <div
                v-if="media.length === 0"
                class="text-center text-subtitle-1 grey--text mt-6 mb-8"
              >
                <div>
                  <v-icon
                    large
                    class="grey--text text--lighten-2"
                  >
                    fal fa-file
                  </v-icon>
                </div>
                <div class="mt-3">
                  {{ $t("media_empty") }}
                </div>
              </div>
              <div>
                <v-row>
                  <v-col
                    v-for="(mediaItem, mediaItemIndex) in media"
                    :key="mediaItem.id"
                    cols="4"
                  >
                    <media-grid-item
                      :media-item="mediaItem"
                      @delete="mediaItem.id ? startDelete(mediaItem) : media.splice(mediaItemIndex, 1)"
                      @preview="preview(mediaItem)"
                    />
                  </v-col>
                </v-row>
              </div>

              <media-viewer-dialog
                :visible.sync="mediaViewerDialog.visible"
                :media="media"
                :view-media-id="mediaViewerDialog.media ? mediaViewerDialog.media.id : undefined"
                :player="player"
                @media:updated="updateMedia"
                @media:deleted="removeMedia"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <template
      v-if="injury.data"
      v-slot:actions
    >
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn
          v-if="$can('delete-medical')"
          small
          text
          color="error"
          class="text-none"
          @click="deleteConfirmationDialogVisible = true"
        >
          <v-icon
            left
            x-small
          >
            far fa-trash
          </v-icon>
          {{ $t('button.delete') }}
        </v-btn>
        <v-spacer />
        <v-btn
          text
          color="grey"
          large
          class="text-none"
          @click="modalVisible = false"
        >
          {{ $t('button.close') }}
        </v-btn>
        <v-btn
          v-if="!injury.data.completed_date && nextPhase && $can('edit-medical')"
          color="primary"
          class="text-none"
          large
          @click="startNextPhase.date = $dayjs(lastPhase.date).isAfter($dayjs(), 'day') ? $dayjs(lastPhase.date).format('YYYY-MM-DD') : $dayjs().format('YYYY-MM-DD'); startNextPhase.dialog = true"
        >
          Start
          {{ nextPhase.text }}
          <v-icon
            right
            small
          >
            far fa-arrow-right
          </v-icon>
        </v-btn>
      </v-card-actions>
    </template>

    <card-dialog
      v-if="nextPhase"
      v-model="startNextPhase.dialog"
      :title="$t('injury_individual.start_next_phase', {phase: nextPhase.text})"
      max-width="400px"
    >
      <v-card-text class="pa-6">
        <validation-observer ref="nextPhaseValidationObserver">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
          >
            <v-menu
              v-model="startNextPhase.dateSelectorActive"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="startNextPhase.date ? $dayjs(startNextPhase.date).format('ll') : ''"
                  :label="$t('picker.date.select_start_date.title')"
                  outlined
                  :error-messages="errors"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="startNextPhase.date"
                :first-day-of-week="1"
                no-title
                :min="lastPhase.date"
                @change="startNextPhase.dateSelectorActive = false"
              />
            </v-menu>
          </validation-provider>
        </validation-observer>
      </v-card-text>

      <template v-slot:actions>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            large
            class="text-none"
            :loading="startNextPhase.submitting"
            @click="submitNextPhase()"
          >
            {{ $t("button.start") }}
            <v-icon
              right
              small
            >
              far fa-check
            </v-icon>
          </v-btn>
        </v-card-actions>
      </template>
    </card-dialog>

    <card-dialog
      v-if="selectedPhase"
      v-model="editPhase.dialog"
      :title="'Edit ' + selectedPhase.text"
      max-width="400px"
    >
      <v-card-text class="pa-6">
        <validation-observer ref="editPhaseValidationObserver">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
          >
            <v-menu
              v-model="editPhase.dateSelectorActive"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="editPhase.date ? $dayjs(editPhase.date).format('ll') : ''"
                  :label="$t('picker.date.select_start_date.title')"
                  outlined
                  :error-messages="errors"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="editPhase.date"
                :first-day-of-week="1"
                no-title
                :min="selectedPreviousPhase && selectedPreviousPhase.date ? selectedPreviousPhase.date : undefined"
                :max="selectedNextPhase && selectedNextPhase.date ? selectedNextPhase.date : undefined"
                @change="editPhase.dateSelectorActive = false"
              />
            </v-menu>
          </validation-provider>
        </validation-observer>
      </v-card-text>

      <template v-slot:actions>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            large
            class="text-none"
            :loading="editPhase.submitting"
            @click="savePhase()"
          >
            {{ $t('training_builder.button.save') }}
            <v-icon
              right
              small
            >
              far fa-check
            </v-icon>
          </v-btn>
        </v-card-actions>
      </template>
    </card-dialog>

    <card-dialog
      v-if="selectedPhase"
      v-model="newNote.dialog"
      :title="$t('add_note.dialog.header')"
      max-width="800px"
    >
      <validation-observer ref="noteValidationObserver">
        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <rich-text-editor
            v-model="newNote.text"
            class="white"
            :placeholder="$t('text_input.enter_note_for.placeholder') + ' ' + selectedPhase.text"
          />
          <div
            v-if="errors.length > 0"
            class="caption error--text"
          >
            {{ errors[0] }}
          </div>
        </validation-provider>
      </validation-observer>

      <template v-slot:actions>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            :loading="newNote.submitting"
            @click="submitNote()"
          >
            {{ $t('training_builder.button.save') }}
          </v-btn>
        </v-card-actions>
      </template>
    </card-dialog>

    <delete-confirmation-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      @confirmed="!deleteMedia ? deleteInjury() : destroy()"
    />
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import { CharacterList, ContactList, InjuryPhase, InjuryPhases, MechanismList } from '@/data/models/Injury'
import HumanBodyFrontMuscles from '@/components/human-body/HumanBodyFrontMuscles.vue'
import HumanBodyFemaleFrontMuscles from '@/components/human-body/HumanBodyFemaleFrontMuscles.vue'
import HumanBodyBackMuscles from '@/components/human-body/HumanBodyBackMuscles.vue'
import HumanBodyFemaleBackMuscles from '@/components/human-body/HumanBodyFemaleBackMuscles.vue'
import Subtitle from '@/components/helpers/Subtitle.vue'
import PlayerNote from '@/components/players/PlayerNote.vue'
import { InjuryApiService } from '@/data/services/InjuryApiService'
import RichTextEditor from '@/components/inputs/RichTextEditor.vue'
import _axios from '@/plugins/axios'
import { MediaApiService } from '@/data/services/MediaApiService'
import { cloneDeep, orderBy } from 'lodash'
import MediaGridItem from '@/components/helpers/MediaGridItem.vue'
import MediaViewerDialog from '@/components/dialogs/MediaViewerDialog.vue'
import DeleteConfirmationDialog from '@/components/dialogs/DeleteConfirmationDialog.vue'
import { PlayerApiService } from '@/data/services'
import LineChart from '../charts/LineChart.vue'
import { PerformanceTableHeaders } from '@/data/models/TableHeader'
import { EventBus } from '@/plugins/bus'
import dayjs from 'dayjs'
import { getDateTimeFormatForUser, toCamelCase } from '@/utils/helpers'

export default {
  name: 'PlayerInjuryDialog',
  components: {
    DeleteConfirmationDialog,
    MediaViewerDialog,
    MediaGridItem,
    RichTextEditor,
    PlayerNote,
    Subtitle,
    HumanBodyFemaleBackMuscles,
    HumanBodyBackMuscles,
    HumanBodyFemaleFrontMuscles,
    HumanBodyFrontMuscles,
    LineChart,
    CardDialog
  },
  mixins: [deleteConfirmationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    injuryId: {
      type: Number,
      required: true
    },
    player: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      injury: {
        loading: false,
        data: undefined
      },
      trendStats: {
        loading: false,
        data: undefined
      },
      injuryPhases: [],
      selectedPhaseKey: 'injury',
      newNote: {
        dialog: false,
        text: '',
        submitting: false
      },
      startNextPhase: {
        dialog: false,
        date: undefined,
        submitting: false,
        dateSelectorActive: false
      },
      editPhase: {
        dialog: false,
        date: undefined,
        dateSelectorActive: false,
        submitting: false
      },
      fileUpload: {
        isDragging: false
      },
      media: [],
      mediaViewerDialog: {
        visible: false,
        media: undefined
      },
      deleteMedia: undefined,
      deleting: false,
      selectedITLVariable: { key: 'TL_DL', text: 'Daily Load' },
      selectedGPSVariable: { id: 0, value: 'UXPCSTD', text: 'T. Distance', sortable: true, colorable: true },
      selectedHRVariable: { value: 'ZONE5DR', text: 'VO2 Max Zone', sortable: true }
    }
  },
  computed: {
    EventBus() {
      return EventBus
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    selectedPhase() {
      if (!this.selectedPhaseKey) return undefined

      return this.injuryPhases.find(p => p.key === this.selectedPhaseKey)
    },
    lastPhase() {
      return this.injuryPhases.findLast(p => !!p.date)
    },
    nextPhase() {
      return this.injuryPhases.find(p => !p.date)
    },
    selectedPreviousPhase() {
      if (!this.selectedPhase) return undefined

      const selectedIndex = this.injuryPhases.findIndex(p => p.key === this.selectedPhase.key)

      return this.injuryPhases[selectedIndex - 1] || undefined
    },
    selectedNextPhase() {
      if (!this.selectedPhase) return undefined

      const selectedIndex = this.injuryPhases.findIndex(p => p.key === this.selectedPhase.key)

      return this.injuryPhases[selectedIndex + 1] || undefined
    },
    bodyParts() {
      if (!this.injury.data) return {}

      const object = {}

      for (const bp of this.injury.data.injury_body_parts) {
        object[bp.main_body_part] = 3
      }

      return object
    },
    bodyPartsText() {
      if (!this.injury.data.injury_body_parts) return undefined

      return this.injury.data.injury_body_parts.map(p => p.name).join(', ')
    },
    itlVariables() {
      if (!this.trendStats.data) return []

      const headers = [
        { key: 'TG_DL', text: this.$t('variables.TG.long') },
        { key: 'TL_DL', text: this.$t('variables.TL.long') },
        { key: 'TTM_DL', text: this.$t('variables.TTM.long') },
        { key: 'ENJY_DL', text: this.$t('variables.ENJY.long') },

        { key: 'FAT', text: this.$t('variables.FAT.long') },
        { key: 'SLQ', text: this.$t('variables.SLQ.long') },
        { key: 'SLD', text: this.$t('variables.SLD.long') },
        { key: 'GMS', text: this.$t('variables.GMS.long') },
        { key: 'STL', text: this.$t('variables.STL.long') },
        { key: 'MOO', text: this.$t('variables.MOO.long') },
        { key: 'player_wellness', text: this.$t('variables.player_wellness.long') },
        { key: 'pain_max_DL', text: this.$t('variables.pain.long') }
      ]
      return headers.filter(header => {
        const values = this.trendStats.data.map(day => day.stats[header.key])
        return !(values.length === values.filter(val => val === null || val === undefined).length)
      })
    },
    gpsVariables() {
      if (!this.trendStats.data) return []

      const headers = PerformanceTableHeaders.data

      return headers.filter(header => {
        const values = this.trendStats.data.map(day => day.stats[header.value + '_DL'])
        return !(values.length === values.filter(val => val === null || val === undefined).length)
      })
    },
    hrVariables() {
      if (!this.trendStats.data) return []

      const headers = [
        { value: 'HRMAX', text: this.$t('hr_variables.max_heart_rate') },
        { value: 'HRAVG', text: this.$t('hr_variables.avg_heart_rate') },
        { value: 'TRIMP', text: this.$t('hr_variables.trimp') },
        { value: 'TRIMPMIN', text: this.$t('hr_variables.trimp_min') },
        { value: 'ZONE1DR', text: this.$t('hr_variables.regeneration_zone') },
        { value: 'ZONE2DR', text: this.$t('hr_variables.ext_aerobic_zone') },
        { value: 'ZONE3DR', text: this.$t('hr_variables.int_aerobic_zone') },
        { value: 'ZONE4DR', text: this.$t('hr_variables.anaerobic_threshold_zone') },
        { value: 'ZONE5DR', text: this.$t('hr_variables.vo2_max_zone') }
      ]

      return headers.filter(header => {
        const values = this.trendStats.data.map(day => day.stats[header.value + '_DL'])
        return !(values.length === values.filter(val => val === null || val === undefined).length)
      })
    },
    hasItlModule() {
      return this.user.organisation_settings.has_itl_module || false
    },
    hasGpsModule() {
      return this.user.organisation_settings.has_gps_module || false
    },
    hasHrModule() {
      return this.user.organisation_settings.has_heart_rate_module || false
    },
    hasTrainingBuilderModule() {
      return this.user.organisation_settings.has_training_builder_module || false
    }
  },
  watch: {
    injuryId() {
      this.fetchInjury()
      this.fetchTrendStats()
    },
    selectedPhaseKey() {
      this.initMedia()
    }
  },
  created() {
    this.injuryPhase = InjuryPhases
    this.injuryPhaseInjury = InjuryPhase.INJURY
    this.injuryPhasePreInjury = 'pre-injury'
    this.character = CharacterList
    this.contact = ContactList
    this.mechanism = MechanismList

    this.fetchInjury()

    EventBus.$on(this.$events.INJURY_UPDATED, (injury) => {
      if (injury.id === this.injury.data.id) this.fetchInjury()
    })
  },
  methods: {
    getDateTimeFormatForUser,
    toCamelCase,
    orderBy,
    async fetchInjury(setInjuryPhase = true) {
      this.injuryPhases = []

      try {
        this.injury.loading = true

        const result = await InjuryApiService.fetchInjury(this.injuryId)

        this.injury.data = result.data

        this.fetchTrendStats()
        this.initInjuryPhases()
        this.initMedia()

        if (setInjuryPhase) this.selectedPhaseKey = this.injuryPhaseInjury
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_injury.error'),
          color: 'error'
        })

        throw e
      } finally {
        this.injury.loading = false
      }
    },
    async fetchTrendStats() {
      this.trendStats.data = []

      try {
        this.trendStats.loading = true

        const queryParams = {
          page: 1,
          per_page: 30,
          dateTo: dayjs(this.injury.data.date).format('YYYY-MM-DD')
        }

        const result = await PlayerApiService.getStats(this.player.id, queryParams)

        this.trendStats.data = result.data.map(stat => ({
          ...stat,
          stats: Object.fromEntries(
            Object.entries(stat.stats).map(([key, value]) => [key, value ?? 0])
          )
        }))
      } catch (e) {
        this.$store.dispatch('alert', {
          text: this.$t('alert.trend_stats_fetch.error'),
          color: 'error'
        })
        throw e
      } finally {
        this.trendStats.loading = false
      }
    },
    initInjuryPhases() {
      this.injuryPhases = Object.keys(InjuryPhases).map(k => {
        let object = { ...InjuryPhases[k], key: k }

        const phase = this.injury.data.injury_phases.find(p => p.phase === k)

        if (phase) object = { ...object, ...phase }

        return object
      })
    },
    initMedia() {
      if (!this.selectedPhase) return

      this.media = cloneDeep(this.selectedPhase.media)
    },
    async submitNote() {
      if (!(await this.$refs.noteValidationObserver.validate())) return

      await this.saveNote()
    },
    async saveNote() {
      this.newNote.submitting = true

      try {
        await InjuryApiService.submitNote(this.selectedPhase.id, {
          text: this.newNote.text
        })

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.success'),
          color: 'success'
        })

        this.newNote.text = ''
        this.newNote.dialog = false

        this.$refs.noteValidationObserver.reset()

        this.fetchInjury(false)
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.error'),
          color: 'error'
        })
      } finally {
        this.newNote.submitting = false
      }
    },
    async submitNextPhase() {
      if (!(await this.$refs.nextPhaseValidationObserver.validate())) return

      try {
        this.startNextPhase.submitting = true

        const result = await InjuryApiService.startNextPhase(this.injury.data.id, {
          date: this.startNextPhase.date
        })

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.injury_phase_start.success', { phase: this.nextPhase.text }),
          color: 'success'
        })

        this.selectedPhaseKey = this.nextPhase.key
        this.injury.data = result.data

        this.initInjuryPhases()

        this.$emit('update:injuries')

        this.startNextPhase.dialog = false
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.error'),
          color: 'error'
        })
      } finally {
        this.startNextPhase.submitting = false
      }
    },
    initEditPhase() {
      if (!this.selectedPhase) return

      this.editPhase.date = this.$dayjs(this.selectedPhase.date).format('YYYY-MM-DD')
      this.editPhase.dialog = true
    },
    async savePhase() {
      try {
        this.editPhase.submitting = true

        const result = await InjuryApiService.editPhase(this.selectedPhase.id, {
          date: this.editPhase.date
        })

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.selectedPhase.text + this.$t('alert.updated.success'),
          color: 'success'
        })

        this.injury.data = result.data

        this.initInjuryPhases()

        this.$emit('update:injuries')

        this.editPhase.dialog = false
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.note_save.error'),
          color: 'error'
        })
      } finally {
        this.editPhase.submitting = false
      }
    },
    async handleFileChange() {
      await this.$nextTick()

      const files = [...this.$refs.uploadFile.files]

      const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'dkg']

      for (const file of files) {
        const type = file.type
        const extension = file.name.split('.').pop()

        if (type.match('image.*') || type.match('video.*') || type.match('audio.*') || allowedExtensions.indexOf(extension) > -1) {
          this.media.unshift({
            file: file,
            name: file.name,
            progress: 0,
            mime_type: file.type,
            size: file.size,
            upload: true
          })
        } else {
          this.media.unshift({
            file: file,
            name: file.name,
            progress: 0,
            mime_type: file.type,
            size: file.size,
            error: 'File type not allowed'
          })
        }
      }

      this.$refs.uploadFile.value = null

      this.processUpload()
    },
    async processUpload() {
      let formData

      for (const file of this.media.filter(m => !!m.upload)) {
        formData = new FormData()
        formData.append('file', file.file, file.name)

        _axios.post(`injury-phases/${this.selectedPhase.id}/media-upload`, formData, {
          onUploadProgress: (e) => {
            file.progress = Number((e.loaded / e.total) * 100)
          }
        }).then(response => {
          file.upload = false

          Object.assign(file, response.data.media)

          this.fetchInjury()
        }).catch(error => {
          if (error.response && error.response.status === 422) {
            this.$store.dispatch(this.$storeActions.ALERT, {
              color: 'error',
              text: this.$t('alert.file_type_not_allowed.error')
            })

            file.error = this.$t('alert.file_type_not_allowed.error')

            return
          }

          this.$store.dispatch(this.$storeActions.ALERT, {
            color: 'error',
            text: this.$t('alert.uploading_file.error')
          })

          file.error = this.$t('alert.uploading_file.error')
        })
      }
    },
    preview(media) {
      this.mediaViewerDialog.visible = true
      this.mediaViewerDialog.media = media
    },
    dragover(e) {
      this.fileUpload.isDragging = true
    },
    dragleave(e) {
      this.fileUpload.isDragging = false
    },
    dragenter(e) {
      this.fileUpload.isDragging = true
    },
    drop(e) {
      this.$refs.uploadFile.files = e.dataTransfer.files
      this.handleFileChange()
      this.fileUpload.isDragging = false
    },
    startDelete(media) {
      this.deleteMedia = media
      this.deleteConfirmationDialogVisible = true
    },
    async destroy() {
      if (!this.deleteMedia) return

      const id = this.deleteMedia.id

      try {
        this.deleting = true

        await MediaApiService.delete(id)

        const index = this.media.findIndex(m => m.id === id)

        if (index > -1) this.media.splice(index, 1)

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.media_delete.success'),
          color: 'success'
        })

        this.deleteConfirmationDialogVisible = false

        this.deleteMedia = undefined

        this.fetchInjury()
        // eslint-disable-next-line no-useless-catch
      } catch (e) {
        throw e
      } finally {
        this.deleting = false
      }
    },
    updateMedia(media) {
      const index = this.media.findIndex(m => m.id === media.id)

      if (index > -1) {
        this.media.splice(index, 1, media)
      }

      this.fetchInjury()
    },
    removeMedia(media) {
      const index = this.media.findIndex(m => m.id === media.id)

      if (index > -1) {
        this.media.splice(index, 1)
      }

      this.fetchInjury()
    },
    async deleteInjury() {
      try {
        this.deleting = true

        await InjuryApiService.deleteInjury(this.injury.data.id)

        this.$emit('update:injuries')

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.injury_delete.success'),
          color: 'success'
        })

        this.deleteConfirmationDialogVisible = false

        this.modalVisible = false
      } catch (e) {

      } finally {
        this.deleting = false
      }
    }
  }
}
</script>

<style lang="scss">
.phase-selector {
  border-radius: 8px;
  cursor: pointer;
  transition: background-color ease-in-out 150ms;

  &.disabled {
    pointer-events: none;
    opacity: .8;
  }

  &:hover {
    background-color: #eeeeee;
  }

  &.active {
    background-color: #d7e1ec;
  }
}
</style>
